export default "__VITE_ASSET__BUbeLDhL__ 100w";